// app/javascript/templates/home.js — M11: plantillas del formulario del home.
// Extraídas de setValue_controller.js (eran métodos de la clase setValue).
// No usan `this`; dependen del import ICONS y del global I18n.
// Se dedentaron 4 espacios SOLO en líneas fuera de template literals para no alterar el HTML generado.
import {ICONS} from '../utils/icons';
import {homeState} from '../utils/home_state';
import {escapeHtml} from '../utils/escape';

export function tpl_section(id, url, picture, helpertext, name, description, background, type, has_divider_top = false, divider_top = '', has_divider_bottom = false, divider_bottom = '', bg_image = '') {
    let faqs_class = '';
    let dt = '';
    let db = '';
    let margin_y = 'margin-y-no-divider';

    if (type === 'faqs') {
        faqs_class = 'justify-content-center'
    }

    let html = `<section id="s_${id}"><div class="row no-print ${faqs_class} ${background}">`;
    switch (type) {
        case 'presentation-with-many-image-and-form':
            homeState.id_array_for_section_with_block.push(id);
            html += `
                 <div class="initial-section">
                   <div class="section-container">
                     <div class="block_primary">
                       <div class="section-information">
                         <div class="section-information-title">
                           <h1>
                             ${escapeHtml(name)}
                           </h1>
                           <p>${escapeHtml(helpertext)}</p>
                         </div>
                         <div class="section-information-button">
                           <a href="javascript:;" class="decoration_none" data-action="setValue#saltarA" data-target="#block_sec_${id}">
                             <span data-target="#block_sec_${id}">
                               ${I18n.t('main.body.catalog.rent_btn')}
                             </span>
                           </a>
                         </div>
                       </div>
                       <div class="section-image">
                         <div class="section-image-background" style="--pict: url(${picture})">
                         </div>
                         <div class="section-image-overlay" style="--overl: url(${divider_top})">
                         </div>
                       </div>
                     </div>
                     <div id="block_sec_${id}" class="block-secondary">
                       <div class="section-bottom-image">
                         <div id="image_b_2" class="section-bottom-image-background image-parallax-efect" style="--pict-two: url(${bg_image})">
                         </div>
                         <div class="section-bottom-image-overlay" style="--overl-two: url(${divider_bottom})">
                         </div>
                       </div>
                       <div id="section_search_form_${id}" class="section-form">
                         <div id="box-form" class="box-form" data-controller="preferences">
                           <!-- TAB PARA EL HEADER DEL FORM -->
                           <ul class="nav nav-tabs" id="home_form" role="tablist">
                             <li class="nav-item ${homeState.car_count_class}" role="presentation">
                               <button class="nav-link active button_with_svg_icon" id="car-tab" data-toggle="tab" data-target="#car" data-form-type="car" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="car" aria-selected="true">
                                 ${ICONS['car']}
                                 <p class="d-none d-md-inline">Suv Urban</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.safari_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="safari-tab" data-toggle="tab" data-target="#safari" data-form-type="safari" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="safari" aria-selected="false">
                                 ${ICONS['safari']}
                                 <p class="d-none d-md-inline">Excursiones</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.excursion_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="excursiones-tab" data-toggle="tab" data-target="#excursiones" data-form-type="excursion" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="excursiones" aria-selected="false">
                                 ${ICONS['excursion']}   
                                 <p class="d-none d-md-inline">Excursiones</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.accessible_tourism_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="accessible_tourism-tab" data-toggle="tab" data-target="#accessible_tourism" data-form-type="accessible_tourism" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="accessible_tourism" aria-selected="false">
                                 ${ICONS['accessible_tourism']}   
                                 <p class="d-none d-md-inline">Turismo Accesible</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.rural_tourism_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="rural_tourism-tab" data-toggle="tab" data-target="#rural_tourism" data-form-type="rural_tourism" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="rural_tourism" aria-selected="false">
                                 ${ICONS['rural_tourism']}   
                                 <p class="d-none d-md-inline">Turismo Rural</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.horseback_ride_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="horseback_ride-tab" data-toggle="tab" data-target="#horseback_ride" data-form-type="horseback_ride" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="horseback_ride" aria-selected="false">
                                 ${ICONS['horseback_ride']}   
                                 <p class="d-none d-md-inline">Cabalgata</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.events_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="events-tab" data-toggle="tab" data-target="#events" data-form-type="events" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="events" aria-selected="false">
                                 ${ICONS['events']}
                                 <p class="d-none d-md-inline">Eventos</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.home_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="home-tab" data-toggle="tab" data-target="#home" data-form-type="home" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="home" aria-selected="false">
                                 ${ICONS['safari']}
                                 <p class="d-none d-md-inline">${I18n.t('reservation.side_bar.home')}</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.buggy_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="buggy-tab" data-toggle="tab" data-target="#buggy" data-form-type="buggy" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="buggy" aria-selected="false">
                                 ${ICONS['safari']}
                                 <p class="d-none d-md-inline">${I18n.t('reservation.side_bar.buggy')}</p>
                               </button>
                             </li>
                             <input id="search_form_type" type="hidden" value="car">
                           </ul>
                          
                             <!-- CUERPO DE LOS TAB -->
                           <div class="tab-content" id="home_form_content">
                             <!-- Formulario CAR - AUTOS -->
                             <div class="tab-pane fade show active" id="car" role="tabpanel" aria-labelledby="car-tab" data-controller="tooltip">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <label for="car_to" data-preferences-target="textDestination"></label>
                                       <select id="car_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_recogida"></span>
                                       <label for="car_collect_place" data-preferences-target="carCollectPlace" class="text-shadow">${I18n.t('histories.check_reservation.pickup_place')}</label>
                                       <select id="car_collect_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_recogida" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_entrega"></span>
                                       <label for="car_delivery_place" data-preferences-target="carDeliveryPlace" class="text-shadow">${I18n.t('histories.check_reservation.droppof_place')}</label>
                                       <select id="car_delivery_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_entrega" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>                                   
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <label for="car_category" data-preferences-target="carCategory" class="text-shadow">${I18n.t('reservation.side_bar.category')}</label>
                                       <div id="text_category" class="">
                                         <select id="car_category" class="form-control required box-shadow"></select>
                                       </div>
                                       <span class="helper-text small"></span>
                                     </div>
                                     
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="car_date_collect" data-preferences-target="carDateCollect" class="text-shadow">${I18n.t('reservation.side_bar.pickup_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="car_date_collect" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_collect" data-isdate="true" readonly="readonly">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <label for="car_time_collect" class="sr-only">Hora específica de recogida</label>
                                           <input type="text" id="car_time_collect" class="form-control timepicker required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_collect" data-isdate="false" readonly="readonly">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="car_date_delivery" data-preferences-target="carDateDelivery" class="text-shadow">${I18n.t('reservation.side_bar.dropoff_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="car_date_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_delivery" data-isdate="true" readonly="readonly">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <label for="car_time_delivery" class="sr-only">Hora específica de entrega</label>
                                           <input type="text" id="car_time_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_delivery" data-isdate="false" readonly="true">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <!-- <div class="row">-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <div class="col-md-12 m-0 p-0">-->
                               <!--         <input type="checkbox" id="has_drivers" class="">-->
                               <!--         <label for="has_drivers" data-preferences-target="manyDrivers" class="text-shadow">¿Tiene conductor adicional?</label>                -->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--       <div id="drivers_count" class="col-md-12  ocultar">-->
                               <!--         <label for="drivers" data-preferences-target="drivers" class="text-shadow">Cantidad de Conductores</label>-->
                               <!--         <select id="drivers" class="form-control box-shadow"></select>-->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <input type="checkbox" id="supplement_insurance" class="">-->
                               <!--       <label for="supplement_insurance" data-preferences-target="supplementInsurance" class="text-shadow">Suplemento de Edad</label>-->
                               <!--       <span class="helper-text small"></span>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!-- </div>-->
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="car_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="car" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="car" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario CAR - AUTOS FINNN -->
                             <div class="tab-pane fade show" id="safari" role="tabpanel" aria-labelledby="safari-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_to" data-preferences-target="textDestination">${I18n.t('reservation.side_bar.destiny')}</label>
                                       <select id="safari_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_modality" data-preferences-target="modality"></label>
                                       <select id="safari_modality" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                        <!-- EXCURSION PAX -->
                                     <div id="safari_pax_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_pax"> Pax </label>
                                       <select id="safari_pax" class="select-form c2ec_select"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                     <div id="safari_adult_childrens" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                       <!-- ADULTOS Y NIÑOS -->
                                       <div class="row p-0 m-0">
                                         <div class="col p-0">
                                           <label for="safari_adultos"> ${I18n.t('reservation.side_bar.adults')} </label>
                                           <input id="safari_adultos" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="safari_childrens" data-block="safari_btn" data-helper="safari_adult_childrens_helper">
                                         </div>
                                         <div class="col p-0">
                                           <label for="safari_childrens"> ${I18n.t('reservation.side_bar.children')} </label>
                                           <input id="safari_childrens" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="safari_adultos" data-block="safari_btn" data-helper="safari_adult_childrens_helper">
                                         </div>
                                       </div>
                                       <span id="safari_adult_childrens_helper" class="helper-text small"></span>
                                     </div>
                                       <!-- ECURSION CANTIDAD -->
                                     <div id="safari_cantidad_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                       <label for="safari_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                                       <input id="safari_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION FECHA -->
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_date" data-preferences-target="dateCollect"></label>
                                       <input id="safari_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION UBICACION -->
                                     <div id="excursion_location_container" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                          <label for="excursion_location"> ${I18n.t('reservation.side_bar.pickup_place')}</label>
                                          <input id="excursion_location" type="text" class="form-control" placeholder="${I18n.t('reservation.side_bar.pickup_place')}" data-action="preferences#make_comment" data-text="Ubicación: ">
                                          <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                                     </div>
                                       <!-- EXCURSION IDIOMA -->
                                     <div id="excursion_lang_container" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                         <label for="excursion_lang"> ${I18n.t('reservation.side_bar.lang')}</label>
                                         <select id="excursion_lang" class="form-control"></select>
                                         <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="safari_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="safari" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="safari" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <div class="tab-pane fade show " id="excursiones" role="tabpanel" aria-labelledby="excursiones-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-md-3">
                                       <label for="excursions_to" data-preferences-target="textDestination"></label>
                                       <select id="excursions_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>
                
                                     <div class="form-group col-md-3">
                                       <label for="excursions_type" data-preferences-target="category"></label>
                                       <select id="excursions_type" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-md-3">
                                       <label for="excursions_modality" data-preferences-target="modality"></label>
                                       <select id="excursions_modality" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                       <!-- EXCURSION PAX -->
                                     <div id="excursions_pax_block" class="form-group col-md-3">
                                       <label for="excursions_pax"> Pax </label>
                                       <select id="excursions_pax" class="select-form c2ec_select"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                     <div id="excursions_adult_childrens" class="form-group col-md-3 ocultar">
                                       <!-- ADULTOS Y NIÑOS -->
                                       <div class="row p-0 m-0">
                                         <div class="col p-0">
                                           <label for="excursions_adultos"> ${I18n.t('reservation.side_bar.adults')} </label>
                                           <input id="excursions_adultos" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="excursion_childrens" data-block="excursion_btn" data-helper="excursion_adult_childrens_helper">
                                         </div>
                                         <div class="col p-0">
                                           <label for="excursions_childrens"> ${I18n.t('reservation.side_bar.children')} </label>
                                           <input id="excursions_childrens" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="excursion_adultos" data-block="excursion_btn" data-helper="excursion_adult_childrens_helper">
                                         </div>
                                       </div>
                                       <span id="excursions_adult_childrens_helper" class="helper-text small"></span>
                                     </div>
                                       <!-- ECURSION CANTIDAD -->
                                     <div id="excursions_cantidad_block" class="form-group col-md-3 ocultar">
                                       <label for="excursions_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                                       <input id="excursions_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION FECHA -->
                                     <div class="form-group col-md-3">
                                       <label for="excursions_date" data-preferences-target="dateCollect"></label>
                                       <input id="excursions_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION UBICACION -->
                                     <div id="excursions_location_container" class="form-group col-md-3 ocultar">
                                       <label for="excursions_location"> ${I18n.t('reservation.side_bar.pickup_place')}</label>
                                       <input id="excursions_location" type="text" class="form-control" placeholder="${I18n.t('reservation.side_bar.pickup_place')}" data-action="preferences#make_comment" data-text="Ubicación: ">
                                       <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                                     </div>
                                       <!-- EXCURSION IDIOMA -->
                                     <div id="excursions_lang_container" class="form-group col-md-3 ocultar">
                                       <label for="excursions_lang"> ${I18n.t('reservation.side_bar.lang')}</label>
                                       <select id="excursions_lang" class="form-control"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="excursions_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="excursiones" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="excursiones" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <div class="tab-pane fade show" id="rural_tourism" role="tabpanel" aria-labelledby="rural_tourism-tab">
                               <div class="row">
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="rural_tourism_to">${I18n.t('reservation.side_bar.destiny')}</label>
                                   <select id="rural_tourism_to" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="rural_tourism_service">${I18n.t('reservation.side_bar.service')}</label>
                                   <select id="rural_tourism_service" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <!-- <label for="rural_tourism_date" data-preferences-target="dateCollect"></label>-->
                                   <label for="rural_tourism_date">${I18n.t('reservation.side_bar.date')}</label>
                                   <input id="rural_tourism_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="rural_tourism_cantidad" data-preferences-target="modality">${I18n.t('reservation.side_bar.person_amount')}</label>
                                   <input type="number" id="rural_tourism_cantidad" class="form-control required" data-action="change->preferences#evaluate blur->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-lg-8">
                                   <label for="rural_tourism_observaciones">${I18n.t('histories.check_reservation.comment')}</label>
                                   <textarea id="rural_tourism_observaciones" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: "></textarea>
                                   <span class="helper-text small"></span>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="rural_tourism_btn" class="form_send" type="button" data-action="b2b#create_reservation" data-validate="rural_tourism" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="rural_tourism" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <div class="tab-pane fade show" id="horseback_ride" role="tabpanel" aria-labelledby="horseback_ride-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <label for="horseback_to">${I18n.t('reservation.side_bar.destiny')}</label>
                                       <select id="horseback_to" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <label for="horseback_service">${I18n.t('reservation.side_bar.service')}</label>
                                       <select id="horseback_service" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <!-- <label for="rural_tourism_date" data-preferences-target="dateCollect"></label>-->
                                       <label for="horseback_date">${I18n.t('reservation.side_bar.date')}</label>
                                       <input id="horseback_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <label for="horseback_cantidad" data-preferences-target="modality">${I18n.t('reservation.side_bar.person_amount')}</label>
                                       <input type="number" id="horseback_cantidad" class="form-control required" data-action="change->preferences#evaluate blur->preferences#evaluate keyup->preferences#evaluate" data-min="0" data-max="50" data-block="horseback_ride_btn">
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-12 col-lg-8">
                                       <label for="horseback_observaciones">${I18n.t('histories.check_reservation.comment')}</label>
                                       <textarea id="horseback_observaciones" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: "></textarea>
                                       <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                                 <div class="col-md-12 p-0">
                                   <div class="d-flex justify-content-end" style="padding: 15px 0;width: 100%;">
                                     <button id="horseback_ride_btn" class="form_send" type="button" data-action="b2b#create_reservation" data-validate="horseback_ride" data-addtocart="true">
                                       <span data-preferences-target="textButton" data-validate="horseback_ride" data-addtocart="true"></span>
                                     </button>
                                   </div>
                                 </div>
                               </div>
                             </div>
                             <div class="tab-pane fade show" id="events" role="tabpanel" aria-labelledby="events-tab">
                               <div class="row">
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_product">${I18n.t('global.section_an_page.events')}</label>
                                   <select id="event_product" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_modality">${I18n.t('reservation.side_bar.alojam')}</label>
                                   <select id="event_modality" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
<!--                                 <div class="form-group col-12 col-md-6 col-lg-4">-->
<!--                                   <label for="event_category_person">Categoría</label>-->
<!--                                   <select id="event_category_person" class="form-control required"></select>-->
<!--                                   <span class="helper-text small"></span>-->
<!--                                 </div>-->
<!--                                 <div class="form-group col-12 col-md-6 col-lg-4 ocultar">-->
<!--                                   <label for="event_entity">Nombre de entidad</label>-->
<!--                                   <input id="event_entity" class="form-control" type="text">-->
<!--                                   <span class="helper-text small"></span>-->
<!--                                 </div>-->
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_amount">Cantidad de habitaciones</label>
                                   <input id="event_amount" class="form-control required" type="number">
                                   <span class="helper-text small"></span>
                                 </div>
<!--                                 <div class="form-group col-12 col-md-6 col-lg-4">-->
<!--                                   <label for="event_pax">Cantidad de personas</label>-->
<!--                                   <input id="event_pax" class="form-control required" type="number">-->
<!--                                   <span class="helper-text small"></span>-->
<!--                                 </div>-->
                                 
                                 <div class="col-md-12 p-0">
                                   <div class="d-flex justify-content-end" style="padding: 15px 0;width: 100%;">
                                     <button id="event_btn" class="form_send" type="button" data-action="b2b#create_reservation" data-validate="events" data-addtocart="true">
                                       <span data-preferences-target="textButton" data-validate="events" data-addtocart="true"></span>
                                     </button>
                                   </div>
                                 </div>
                               </div>
                             </div>
                             
                             <div class="tab-pane fade show" id="home" role="tabpanel" aria-labelledby="home-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="home_to" data-preferences-target="textDestination">${I18n.t('reservation.side_bar.destiny')}</label>
                                       <select id="home_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="home_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="home" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="home" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
                `;
            break;
        case 'presentation-image-and-form':
            /*homeState.id_array_for_section_with_block.push(id);*/

            /* para el cuadro gris del inicio */
            /*<div className="section-information">
                <div className="section-information-title">
                    <h1>
                        ${escapeHtml(name)}
                    </h1>
                    <p>${escapeHtml(helpertext)}</p>
                </div>
                <div className="section-information-button">
                    <a href="javascript:;" className="decoration_none" data-action="setValue#saltarA" data-target="#block_sec_${id}">
                         <span data-target="#block_sec_${id}">
                           ${I18n.t('main.body.catalog.rent_btn')}
                         </span>
                    </a>
                </div>
            </div>*/
            html += `
                 <div class="initial-section-2">
                   <div class="section-container-2">
                     <div class="block_primary">
                       
                       <div class="section-image-2">
                         <div class="section-image-background" style="--pict: url(${picture})">
                         </div>
                       </div>
                     </div>
                     <div id="block_sec_${id}" class="block-secondary-2">
                       <div id="section_search_form_${id}" class="section-form-2">
                         <div id="box-form" class="box-form-2" data-controller="preferences">
                           <!-- TAB PARA EL HEADER DEL FORM -->
                           <ul class="nav nav-tabs" id="home_form" role="tablist">
                             <li class="nav-item ${homeState.car_count_class}" role="presentation">
                               <button class="nav-link active button_with_svg_icon" id="car-tab" data-toggle="tab" data-target="#car" data-form-type="car" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="car" aria-selected="true">
                                 ${ICONS['car_2']}
                                 <p class="d-none d-md-inline">Suv Urban</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.safari_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="safari-tab" data-toggle="tab" data-target="#safari" data-form-type="safari" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="safari" aria-selected="false">
                                 ${ICONS['safari_2']}
                                 <p class="d-none d-md-inline">Excursiones</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.home_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="home-tab" data-toggle="tab" data-target="#home" data-form-type="home" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="home" aria-selected="false">
                                 <svg width="200px" height="200px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                   <path d="M22 22L2 22" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
                                   <path d="M2 11L6.06296 7.74968M22 11L13.8741 4.49931C12.7784 3.62279 11.2216 3.62279 10.1259 4.49931L9.34398 5.12486" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
                                   <path d="M15.5 5.5V3.5C15.5 3.22386 15.7239 3 16 3H18.5C18.7761 3 19 3.22386 19 3.5V8.5" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
                                   <path d="M4 22V9.5" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
                                   <path d="M20 9.5V13.5M20 22V17.5" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
                                   <path d="M15 22V17C15 15.5858 15 14.8787 14.5607 14.4393C14.1213 14 13.4142 14 12 14C10.5858 14 9.87868 14 9.43934 14.4393M9 22V17" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                   <path d="M14 9.5C14 10.6046 13.1046 11.5 12 11.5C10.8954 11.5 10 10.6046 10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5Z" stroke="#1C274C" stroke-width="1.5"/>
                                 </svg>
                                 <p class="d-none d-md-inline">${I18n.t('reservation.side_bar.home')}</p>
                               </button>
                             </li>
                             <li class="nav-item " role="presentation">
                               <button class="nav-link button_with_svg_icon" id="hotetec-tab" data-toggle="tab" data-target="#hotetec" data-form-type="hotetec" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="hotetec" aria-selected="false">
                                 <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icons-tabler-outline icon-tabler-circle-dotted-letter-h feather" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                   <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                   <path d="M10 16v-8m4 0v8"/>
                                   <path d="M10 12h4"/>
                                   <path d="M7.5 4.21v.01"/>
                                   <path d="M4.21 7.5v.01"/>
                                   <path d="M3 12v.01"/>
                                   <path d="M4.21 16.5v.01"/>
                                   <path d="M7.5 19.79v.01"/>
                                   <path d="M12 21v.01"/>
                                   <path d="M16.5 19.79v.01"/>
                                   <path d="M19.79 16.5v.01"/>
                                   <path d="M21 12v.01"/>
                                   <path d="M19.79 7.5v.01"/>
                                   <path d="M16.5 4.21v.01"/>
                                   <path d="M12 3v.01"/>
                                 </svg>
                                 <p class="d-none d-md-inline">Hoteles</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.excursion_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="excursiones-tab" data-toggle="tab" data-target="#excursiones" data-form-type="excursion" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="excursiones" aria-selected="false">
                                 ${ICONS['excursion']}   
                                 <p class="d-none d-md-inline">Excursiones</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.accessible_tourism_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="accessible_tourism-tab" data-toggle="tab" data-target="#accessible_tourism" data-form-type="accessible_tourism" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="accessible_tourism" aria-selected="false">
                                 ${ICONS['accessible_tourism']}   
                                 <p class="d-none d-md-inline">Turismo Accesible</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.buggy_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="buggy-tab" data-toggle="tab" data-target="#buggy" data-form-type="buggy" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="buggy" aria-selected="false">
                                 ${ICONS['buggy']}
                                 <p class="d-none d-md-inline">${I18n.t('reservation.side_bar.buggy')}</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.transfers_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="transfers-tab" data-toggle="tab" data-target="#transfers" data-form-type="transfers" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="transfers" aria-selected="false">
                                 ${ICONS['transfers']}
                                 <p class="d-none d-md-inline">${I18n.t('reservation.side_bar.transfers')}</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.bicicleta_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="bicicleta-tab" data-toggle="tab" data-target="#bicicleta" data-form-type="bicicleta" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="bicicleta" aria-selected="false">
                                 ${ICONS['bicicleta']}
                                 <p class="d-none d-md-inline">Bicicleta</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.campers_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="campers-tab" data-toggle="tab" data-target="#campers" data-form-type="campers" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="campers" aria-selected="false">
                                 ${ICONS['campers']}
                                 <p class="d-none d-md-inline">Campers</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.bike_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="bike-tab" data-toggle="tab" data-target="#bike" data-form-type="bike" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="bike" aria-selected="false">
                                 ${ICONS['bike']}
                                 <p class="d-none d-md-inline">Moto</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.rural_tourism_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="rural_tourism-tab" data-toggle="tab" data-target="#rural_tourism" data-form-type="rural_tourism" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="rural_tourism" aria-selected="false">
                                 ${ICONS['rural_tourism']}   
                                 <p class="d-none d-md-inline">Turismo Rural</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.horseback_ride_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="horseback_ride-tab" data-toggle="tab" data-target="#horseback_ride" data-form-type="horseback_ride" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="horseback_ride" aria-selected="false">
                                 ${ICONS['horseback_ride']}   
                                 <p class="d-none d-md-inline">Cabalgata</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${homeState.events_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="events-tab" data-toggle="tab" data-target="#events" data-form-type="events" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="events" aria-selected="false">
                                 ${ICONS['events']}
                                 <p class="d-none d-md-inline">Eventos</p>
                               </button>
                             </li>
                             <input id="search_form_type" type="hidden" value="car">
                           </ul>
                          
                             <!-- CUERPO DE LOS TAB -->
                           <div class="tab-content" id="home_form_content">
                             <!-- Formulario CAR - AUTOS -->
                             <div class="tab-pane fade show active" id="car" role="tabpanel" aria-labelledby="car-tab" data-controller="tooltip">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <label for="car_to">Provincia</label>
                                       <select id="car_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_recogida"></span>
                                       <label for="car_collect_place" data-preferences-target="carCollectPlace" class="text-shadow">${I18n.t('histories.check_reservation.pickup_place')}</label>
                                       <select id="car_collect_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_recogida" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_entrega"></span>
                                       <label for="car_delivery_place" data-preferences-target="carDeliveryPlace" class="text-shadow">${I18n.t('histories.check_reservation.droppof_place')}</label>
                                       <select id="car_delivery_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_entrega" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>                                   
                                     </div>
                                     <div id="text_car_category" class="form-group col-12 col-sm-6 col-xl-3 ocultar">
                                       <label for="car_category" data-preferences-target="carCategory" class="text-shadow">${I18n.t('reservation.side_bar.category')}</label>
                                       <div class="">
                                         <select id="car_category" class="form-control box-shadow"></select>
                                       </div>
                                       <span class="helper-text small"></span>
                                     </div>
                                     
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="car_date_collect" data-preferences-target="carDateCollect" class="text-shadow">${I18n.t('reservation.side_bar.pickup_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="car_date_collect" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_collect" data-isdate="true" readonly placeholder="Seleccione fecha de recogida">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <label for="car_time_collect" class="sr-only">Hora específica de recogida</label>
                                           <input type="text" id="car_time_collect" class="form-control timepicker required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_collect" data-isdate="false" readonly disabled placeholder="Seleccione hora">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="car_date_delivery" data-preferences-target="carDateDelivery" class="text-shadow">${I18n.t('reservation.side_bar.dropoff_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="car_date_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_delivery" data-isdate="true" readonly disabled placeholder="Seleccione fecha de entrega">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <label for="car_time_delivery" class="sr-only">Hora específica de entrega</label>
                                           <input type="text" id="car_time_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_delivery" data-isdate="false" readonly disabled placeholder="Seleccione hora">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <!-- <div class="row">-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <div class="col-md-12 m-0 p-0">-->
                               <!--         <input type="checkbox" id="has_drivers" class="">-->
                               <!--         <label for="has_drivers" data-preferences-target="manyDrivers" class="text-shadow">¿Tiene conductor adicional?</label>                -->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--       <div id="drivers_count" class="col-md-12  ocultar">-->
                               <!--         <label for="drivers" data-preferences-target="drivers" class="text-shadow">Cantidad de Conductores</label>-->
                               <!--         <select id="drivers" class="form-control box-shadow"></select>-->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <input type="checkbox" id="supplement_insurance" class="">-->
                               <!--       <label for="supplement_insurance" data-preferences-target="supplementInsurance" class="text-shadow">Suplemento de Edad</label>-->
                               <!--       <span class="helper-text small"></span>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!-- </div>-->
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="car_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="car" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="car" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario CAR - AUTOS FINNN -->
                             <!-- Formulario SAFARI - EXCURSIONES -->
                             <div class="tab-pane fade show" id="safari" role="tabpanel" aria-labelledby="safari-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_to" data-preferences-target="textDestination">${I18n.t('reservation.side_bar.departure_zone')}</label>
                                       <select id="safari_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_modality" data-preferences-target="modality"></label>
                                       <select id="safari_modality" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                        <!-- EXCURSION PAX -->
                                     <div id="safari_pax_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_pax"> Pax </label>
                                       <select id="safari_pax" class="select-form c2ec_select"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                     <div id="safari_adult_childrens" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                       <!-- ADULTOS Y NIÑOS -->
                                       <div class="row p-0 m-0">
                                         <div class="col p-0">
                                           <label for="safari_adultos"> ${I18n.t('reservation.side_bar.adults')} </label>
                                           <input id="safari_adultos" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="safari_childrens" data-block="safari_btn" data-helper="safari_adult_childrens_helper">
                                         </div>
                                         <div class="col p-0">
                                           <label for="safari_childrens"> ${I18n.t('reservation.side_bar.children')} </label>
                                           <input id="safari_childrens" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="safari_adultos" data-block="safari_btn" data-helper="safari_adult_childrens_helper">
                                         </div>
                                       </div>
                                       <span id="safari_adult_childrens_helper" class="helper-text small"></span>
                                     </div>
                                       <!-- ECURSION CANTIDAD -->
                                     <div id="safari_cantidad_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                       <label for="safari_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                                       <input id="safari_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION FECHA -->
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_date" data-preferences-target="dateCollect"></label>
                                       <input id="safari_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION UBICACION -->
                                     <div id="excursion_location_container" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                          <label for="excursion_location"> ${I18n.t('reservation.side_bar.pickup_place')}</label>
                                          <input id="excursion_location" type="text" class="form-control" placeholder="${I18n.t('reservation.side_bar.pickup_place')}" data-action="preferences#make_comment" data-text="Ubicación: ">
                                          <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                                     </div>
                                       <!-- EXCURSION IDIOMA -->
                                     <div id="excursion_lang_container" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                         <label for="excursion_lang"> ${I18n.t('reservation.side_bar.lang')}</label>
                                         <select id="excursion_lang" class="form-control"></select>
                                         <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="safari_btn_info" class="btn btn-info ocultar ml-2">Información</button>
                                   <button id="safari_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="safari" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="safari" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario SAFARI - EXCURSIONES FINNN -->
                             <!-- Formulario CASAS -->
                             <div class="tab-pane fade show" id="home" role="tabpanel" aria-labelledby="home-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-lg-3">
                                       <label for="home_modality">${I18n.t('reservation.side_bar.home')}</label>
                                       <select id="home_modality" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-lg-3" data-controller="flatpickr">
                                       <label for="home_date_range">${I18n.t('hotetec.hotel.range_date')}</label>
                                       <div class="position-relative">
                                         <input id="home_date_range" class="form-control rounded-pill pl-5 pr-3 required" placeholder="${I18n.t('home.page.select_range_date')}" disabled />
                                         <i class="far fa-calendar-alt position-absolute text-muted" style="top: 50%; left: 12px; transform: translateY(-50%);"></i>
                                         <span class="helper-text small"></span>
                                       </div>
                                     </div>
                                     <!-- Información de la casa seleccionada -->
                                     <div class="col-12 col-lg-6 justify-content-center align-items-center" id="home_info_container" style="display: none;">
                                       <div class="card" style="height: fit-content !important;">
                                         <div id="home_carousel" class="carousel slide" data-ride="carousel" style="display: none;">
                                           <div class="carousel-inner" id="home_images">
                                             <!-- Las imágenes se cargarán dinámicamente -->
                                           </div>
                                           <a class="carousel-control-prev" href="#home_carousel" role="button" data-slide="prev">
                                             <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                             <span class="fa fa-arrow-left" style="color: var(--bg-c)"></span>
                                           </a>
                                           <a class="carousel-control-next" href="#home_carousel" role="button" data-slide="next">
                                             <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                             <span class="fa fa-arrow-right" style="color: var(--bg-c)"></span>
                                           </a>
                                         </div>
                                         <div class="card-body" style="padding: 0;">
                                           <div class="row small" style="padding: .5rem; text-align: center;">
                                             <div class="col-12">
                                               <p style="color: var(--txt-highlight-secondary); font-weight: 700; font-size: 1rem; margin-bottom: 0 !important;">${I18n.t('reservation.product.home.max_capacity')}:</p>
                                             </div>
                                             <div class="col-6 col-sm-4">
                                               <i class="fas fa-male"></i> <span id="home_max_adults">0</span> ${I18n.t('reservation.product.home.adult')}
                                             </div>
                                             <div class="col-6 col-sm-4">
                                               <i class="fas fa-child"></i> <span id="home_max_children">0</span> ${I18n.t('reservation.product.home.children')}
                                             </div>
                                             <div class="col-12 col-sm-4">
                                               <i class="fas fa-bed"></i> <span id="home_max_rooms">0</span> ${I18n.t('reservation.product.home.room')}
                                             </div>
                                           </div>
                                           <div class="mt-2 small text-muted" id="home_description" style="display: none;">
                                             <!-- Descripción adicional si la tienes -->
                                           </div>
                                         </div>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="home_btn_info" class="btn btn-info ocultar ml-2">Información</button>
                                   <button id="home_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="home" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="home" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario CASAS FINNN -->
                             <!-- Formulario HOTELES -->
                             <div class="tab-pane fade show" id="hotetec" role="tabpanel" aria-labelledby="hotetec-tab" data-controller="tooltip">
                               <div class="row" data-controller="hotel-search">
                                 <div class="col-md-12">
                                   <div class="row p-0">
                                     <div class="form-group col-12 col-sm-6 col-xl-4">
                                       <label for="hotetec_destination">${I18n.t('reservation.side_bar.destiny')}</label>
                                       <div class="position-relative">
                                         <select id="hotetec_destination" class="form-control required c2ec_select_with_clear rounded-pill pl-5 pr-3" data-hotel-search-target="formDestination"></select>
                                         <i class="fas fa-map-marker-alt position-absolute text-muted" style="top: 50%; left: 7px; transform: translateY(-50%);""></i>
                                         <span class="helper-text small"></span>
                                       </div>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-4" data-controller="flatpickr">
                                       <label for="hotetec_date_range">${I18n.t('hotetec.hotel.range_date')}</label>
                                       <div class="position-relative">
                                         <input id="hotetec_date_range" class="form-control rounded-pill pl-5 pr-3" placeholder="${I18n.t('hotetec.hotel.range_date_placeholder')}" data-hotel-search-target="formRangeDate" />
                                         <i class="far fa-calendar-alt position-absolute text-muted" style="top: 50%; left: 12px; transform: translateY(-50%);"></i>
                                         <span class="helper-text small"></span>
                                       </div>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-4">
                                       <label for="hotetec_rooms">${I18n.t('hotetec.hotel.rooms')}</label>
                                       <div class="position-relative">
                                         <input id="hotetec_rooms" type="number" class="form-control rounded-pill pl-5 pr-3 text-center" data-hotel-search-target="formRooms" value="1" min="1" max="6" data-action="input->hotel-search#sanitizeRooms blur->hotel-search#validateRooms" />
                                         <i class="fas fa-bed position-absolute text-muted" style="top: 50%; left: 12px; transform: translateY(-50%);"></i>
                                         <span class="helper-text small"></span>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="hotetec_btn" class="form_send ml-2" type="button" data-action="hotel-search#go_to_reservar_hotel">
                                     <span data-preferences-target="textButton"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario HOTELES FINNN -->
                             <!-- Formulario EXCURSIONES SOLAS ANTES -->
                             <div class="tab-pane fade show" id="excursiones" role="tabpanel" aria-labelledby="excursiones-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-md-3">
                                       <label for="excursions_to" data-preferences-target="textDestination"></label>
                                       <select id="excursions_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>
                
                                     <div class="form-group col-md-3">
                                       <label for="excursions_type" data-preferences-target="category"></label>
                                       <select id="excursions_type" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-md-3">
                                       <label for="excursions_modality" data-preferences-target="modality"></label>
                                       <select id="excursions_modality" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                       <!-- EXCURSION PAX -->
                                     <div id="excursions_pax_block" class="form-group col-md-3">
                                       <label for="excursions_pax"> Pax </label>
                                       <select id="excursions_pax" class="select-form c2ec_select"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                     <div id="excursions_adult_childrens" class="form-group col-md-3 ocultar">
                                       <!-- ADULTOS Y NIÑOS -->
                                       <div class="row p-0 m-0">
                                         <div class="col p-0">
                                           <label for="excursions_adultos"> ${I18n.t('reservation.side_bar.adults')} </label>
                                           <input id="excursions_adultos" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="excursion_childrens" data-block="excursion_btn" data-helper="excursion_adult_childrens_helper">
                                         </div>
                                         <div class="col p-0">
                                           <label for="excursions_childrens"> ${I18n.t('reservation.side_bar.children')} </label>
                                           <input id="excursions_childrens" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="excursion_adultos" data-block="excursion_btn" data-helper="excursion_adult_childrens_helper">
                                         </div>
                                       </div>
                                       <span id="excursions_adult_childrens_helper" class="helper-text small"></span>
                                     </div>
                                       <!-- ECURSION CANTIDAD -->
                                     <div id="excursions_cantidad_block" class="form-group col-md-3 ocultar">
                                       <label for="excursions_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                                       <input id="excursions_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION FECHA -->
                                     <div class="form-group col-md-3">
                                       <label for="excursions_date" data-preferences-target="dateCollect"></label>
                                       <input id="excursions_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION UBICACION -->
                                     <div id="excursions_location_container" class="form-group col-md-3 ocultar">
                                       <label for="excursions_location"> ${I18n.t('reservation.side_bar.pickup_place')}</label>
                                       <input id="excursions_location" type="text" class="form-control" placeholder="${I18n.t('reservation.side_bar.pickup_place')}" data-action="preferences#make_comment" data-text="Ubicación: ">
                                       <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                                     </div>
                                       <!-- EXCURSION IDIOMA -->
                                     <div id="excursions_lang_container" class="form-group col-md-3 ocultar">
                                       <label for="excursions_lang"> ${I18n.t('reservation.side_bar.lang')}</label>
                                       <select id="excursions_lang" class="form-control"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="excursions_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="excursiones" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="excursiones" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario EXCURSIONES SOLAS ANTES FINNN -->
                             <!-- Formulario TURISMO ACCESIBLE -->
                             <div class="tab-pane fade show" id="accessible_tourism" role="tabpanel" aria-labelledby="accessible_tourism-tab">
                               <div class="row">
                                 <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                   <label for="accessible_tourism_to">Provincia</label>
                                   <select id="accessible_tourism_to" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                   <label for="accessible_tourism_service">${I18n.t('reservation.side_bar.service')}</label>
                                   <select id="accessible_tourism_service" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>                                
                                 <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                   <label for="accessible_tourism_modality">Excursión</label>
                                   <select id="accessible_tourism_modality" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>                             
                                 <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                   <label for="accessible_tourism_pick_up_location">${I18n.t('reservation.side_bar.pick_up_location')}</label>
                                   <button id="accessible_tpul_btn" class="btn btn-sm btn-info ocultar" style="position: absolute; top: -0.5em; right: 1rem;"><i class="fa fa-map-marker" aria-hidden="true"></i> Mapa</button>
                                   <select id="accessible_tourism_pick_up_location" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                   <!-- <label for="accessible_tourism_date" data-preferences-target="dateCollect"></label>-->
                                   <label for="accessible_tourism_date">${I18n.t('reservation.side_bar.date')}</label>
                                   <input id="accessible_tourism_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                   <label for="accessible_tourism_cantidad">${I18n.t('reservation.side_bar.person_amount')}</label>
                                   <input type="number" id="accessible_tourism_cantidad" class="form-control required" data-action="change->preferences#evaluate blur->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-lg-6">
                                   <label for="accessible_tourism_observaciones">${I18n.t('histories.check_reservation.comment')}</label>
                                   <textarea id="accessible_tourism_observaciones" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: " data-pickup="accessible_tourism_pick_up_location"></textarea>
                                   <span class="helper-text small"></span>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="accessible_tourism_btn_info" class="btn btn-info ocultar ml-2">Información</button>
                                   <button id="accessible_tourism_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="accessible_tourism" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="accessible_tourism" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario TURISMO ACCESIBLE FINNN -->
                             <!-- Formulario BUGGY -->
                             <div class="tab-pane fade show" id="buggy" role="tabpanel" aria-labelledby="buggy-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="buggy_to">Provincia</label>
                                       <select id="buggy_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="buggy_modality">Excursión</label>
                                       <select id="buggy_modality" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                        <!-- EXCURSION PAX -->
                                     <div id="buggy_pax_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="buggy_pax"> Pax </label>
                                       <select id="buggy_pax" class="select-form c2ec_select"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                     <div id="buggy_adult_childrens" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                       <!-- ADULTOS Y NIÑOS -->
                                       <div class="row p-0 m-0">
                                         <div class="col p-0">
                                           <label for="buggy_adultos"> ${I18n.t('reservation.side_bar.adults')} </label>
                                           <input id="buggy_adultos" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="buggy_childrens" data-block="buggy_btn" data-helper="buggy_adult_childrens_helper">
                                         </div>
                                         <div class="col p-0">
                                           <label for="buggy_childrens"> ${I18n.t('reservation.side_bar.children')} </label>
                                           <input id="buggy_childrens" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="buggy_adultos" data-block="buggy_btn" data-helper="buggy_adult_childrens_helper">
                                         </div>
                                       </div>
                                       <span id="buggy_adult_childrens_helper" class="helper-text small"></span>
                                     </div>
                                       <!-- ECURSION CANTIDAD -->
                                     <div id="buggy_cantidad_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                       <label for="buggy_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                                       <input id="buggy_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION FECHA -->
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="buggy_date">${I18n.t('reservation.side_bar.date')}</label>
                                       <input id="buggy_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="buggy_btn_info" class="btn btn-info ocultar ml-2">Información</button>
                                   <button id="buggy_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="buggy" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="buggy" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario BUGGY FINNN -->
                             <!-- Formulario TRANSFERS -->
                             <div class="tab-pane fade show" id="transfers" role="tabpanel" aria-labelledby="transfers-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="transfers_to">Provincia</label>
                                       <select id="transfers_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <!-- <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3"> -->
                                     <!--   <label for="transfers_modality">$#{/*I18n.t('reservation.side_bar.modality')*/}</label> -->
                                     <!--   <select id="transfers_modality" class="form-control required"></select> -->
                                     <!--   <span class="helper-text small"></span> -->
                                     <!-- </div> -->
                                                                 
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="transfers_pick_up_location">${I18n.t('reservation.side_bar.pick_up_location')}</label>
                                       <button id="transfers_pul_btn" class="btn btn-sm btn-info ocultar" style="position: absolute; top: -0.5em; right: 1rem;"><i class="fa fa-map-marker" aria-hidden="true"></i> Mapa</button>
                                       <select id="transfers_pick_up_location" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>                             
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="transfers_drop_off_location">${I18n.t('reservation.side_bar.drop_off_location')}</label>
                                       <button id="transfers_dol_btn" class="btn btn-sm btn-info ocultar" style="position: absolute; top: -0.5em; right: 1rem;"><i class="fa fa-map-marker" aria-hidden="true"></i> Mapa</button>
                                       <select id="transfers_drop_off_location" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                     <!-- ECURSION CANTIDAD -->
                                     <div id="transfers_cantidad_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="transfers_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                                       <input id="transfers_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="3">
                                       <span class="helper-text small"></span>
                                     </div>
                                     <!-- EXCURSION FECHA -->
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="transfers_date">${I18n.t('reservation.side_bar.date')}</label>
                                       <input id="transfers_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                     <!-- EXCURSION UBICACION -->
                                     <div class="form-group col-12 col-lg-6">
                                       <label for="transfers_observaciones">${I18n.t('histories.check_reservation.comment')}</label>
                                       <textarea id="transfers_observaciones" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: " data-pickup="transfers_pick_up_location" data-dropoff="transfers_drop_off_location"></textarea>
                                       <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="transfers_btn_info" class="btn btn-info ocultar ml-2">Información</button>
                                   <button id="transfers_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="transfers" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="transfers" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario TRANSFERS FINNN -->
                             <!-- Formulario BICICLETA -->
                             <div class="tab-pane fade show" id="bicicleta" role="tabpanel" aria-labelledby="bicicleta-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="bicicleta_to" data-preferences-target="textDestination">${I18n.t('reservation.side_bar.departure_zone')}</label>
                                       <select id="bicicleta_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="bicicleta_modality">Excursión</label>
                                       <select id="bicicleta_modality" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- ECURSION CANTIDAD -->
                                     <div id="bicicleta_cantidad_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                       <label for="bicicleta_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                                       <input id="bicicleta_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION FECHA -->
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="bicicleta_date">${I18n.t('reservation.side_bar.date')}</label>
                                       <input id="bicicleta_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION UBICACION -->
                                     <div id="excursion_location_container" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                          <label for="excursion_location"> ${I18n.t('reservation.side_bar.pickup_place')}</label>
                                          <input id="excursion_location" type="text" class="form-control" placeholder="${I18n.t('reservation.side_bar.pickup_place')}" data-action="preferences#make_comment" data-text="Ubicación: ">
                                          <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                                     </div>
                                       <!-- EXCURSION IDIOMA -->
                                     <div id="excursion_lang_container" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                         <label for="excursion_lang"> ${I18n.t('reservation.side_bar.lang')}</label>
                                         <select id="excursion_lang" class="form-control"></select>
                                         <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="bicicleta_btn_info" class="btn btn-info ocultar ml-2">Información</button>
                                   <button id="bicicleta_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="bicicleta" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="bicicleta" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario BICICLETA FINNN -->
                             <!-- Formulario CAMPERS -->
                             <div class="tab-pane fade show" id="campers" role="tabpanel" aria-labelledby="campers-tab" data-controller="tooltip">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <label for="campers_to">${I18n.t('reservation.side_bar.destiny')}</label>
                                       <select id="campers_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_recogida_campers"></span>
                                       <label for="campers_collect_place" data-preferences-target="carCollectPlace" class="text-shadow">${I18n.t('histories.check_reservation.pickup_place')}</label>
                                       <select id="campers_collect_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_recogida_campers" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_entrega_campers"></span>
                                       <label for="campers_delivery_place" data-preferences-target="carDeliveryPlace" class="text-shadow">${I18n.t('histories.check_reservation.droppof_place')}</label>
                                       <select id="campers_delivery_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_entrega_campers" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>                                   
                                     </div>
                                     <div id="text_campers_category" class="form-group col-12 col-sm-6 col-xl-3 ocultar">
                                       <label for="campers_category" data-preferences-target="carCategory" class="text-shadow">${I18n.t('reservation.side_bar.category')}</label>
                                       <div class="">
                                         <select id="campers_category" class="form-control box-shadow"></select>
                                       </div>
                                       <span class="helper-text small"></span>
                                     </div>
                                     
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="campers_date_collect" data-preferences-target="carDateCollect" class="text-shadow">${I18n.t('reservation.side_bar.pickup_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="campers_date_collect" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_collect" data-isdate="true" readonly placeholder="Seleccione fecha de recogida">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <label for="campers_time_collect" class="sr-only">Hora específica de recogida</label>
                                           <input type="text" id="campers_time_collect" class="form-control timepicker required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_collect" data-isdate="false" readonly disabled placeholder="Seleccione hora">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="campers_date_delivery" data-preferences-target="carDateDelivery" class="text-shadow">${I18n.t('reservation.side_bar.dropoff_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="campers_date_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_delivery" data-isdate="true" disabled placeholder="Seleccione fecha de entrega">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <label for="campers_time_delivery" class="sr-only">Hora específica de entrega</label>
                                           <input type="text" id="campers_time_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_delivery" data-isdate="false" disabled placeholder="Seleccione hora">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <!-- <div class="row">-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <div class="col-md-12 m-0 p-0">-->
                               <!--         <input type="checkbox" id="has_drivers" class="">-->
                               <!--         <label for="has_drivers" data-preferences-target="manyDrivers" class="text-shadow">¿Tiene conductor adicional?</label>                -->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--       <div id="drivers_count" class="col-md-12  ocultar">-->
                               <!--         <label for="drivers" data-preferences-target="drivers" class="text-shadow">Cantidad de Conductores</label>-->
                               <!--         <select id="drivers" class="form-control box-shadow"></select>-->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <input type="checkbox" id="supplement_insurance" class="">-->
                               <!--       <label for="supplement_insurance" data-preferences-target="supplementInsurance" class="text-shadow">Suplemento de Edad</label>-->
                               <!--       <span class="helper-text small"></span>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!-- </div>-->
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="campers_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="campers" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="campers" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario CAMPERS FINNN -->
                             <!-- Formulario BIKE -->
                             <div class="tab-pane fade show" id="bike" role="tabpanel" aria-labelledby="bike-tab" data-controller="tooltip">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <label for="bike_to">${I18n.t('reservation.side_bar.destiny')}</label>
                                       <select id="bike_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_recogida_bike"></span>
                                       <label for="bike_collect_place" data-preferences-target="carCollectPlace" class="text-shadow">${I18n.t('histories.check_reservation.pickup_place')}</label>
                                       <select id="bike_collect_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_recogida_bike" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_entrega_bike"></span>
                                       <label for="bike_delivery_place" data-preferences-target="carDeliveryPlace" class="text-shadow">${I18n.t('histories.check_reservation.droppof_place')}</label>
                                       <select id="bike_delivery_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_entrega_bike" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>                                   
                                     </div>
                                     <div id="text_bike_category" class="form-group col-12 col-sm-6 col-xl-3 ocultar">
                                       <label for="bike_category" data-preferences-target="carCategory" class="text-shadow">${I18n.t('reservation.side_bar.category')}</label>
                                       <div class="">
                                         <select id="bike_category" class="form-control box-shadow"></select>
                                       </div>
                                       <span class="helper-text small"></span>
                                     </div>
                                     
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="bike_date_collect" data-preferences-target="carDateCollect" class="text-shadow">${I18n.t('reservation.side_bar.pickup_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="bike_date_collect" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_collect" data-isdate="true" readonly disabled placeholder="Seleccione fecha de recogida">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <label for="bike_time_collect" class="sr-only">Hora específica de recogida</label>
                                           <input type="text" id="bike_time_collect" class="form-control timepicker required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_collect" data-isdate="false" readonly disabled placeholder="Seleccione hora">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="bike_date_delivery" data-preferences-target="carDateDelivery" class="text-shadow">${I18n.t('reservation.side_bar.dropoff_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="bike_date_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_delivery" data-isdate="true" readonly disabled placeholder="Seleccione fecha de entrega">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <label for="bike_time_delivery" class="sr-only">Hora específica de entrega</label>
                                           <input type="text" id="bike_time_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_delivery" data-isdate="false" readonly disabled placeholder="Seleccione hora">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <!-- <div class="row">-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <div class="col-md-12 m-0 p-0">-->
                               <!--         <input type="checkbox" id="has_drivers" class="">-->
                               <!--         <label for="has_drivers" data-preferences-target="manyDrivers" class="text-shadow">¿Tiene conductor adicional?</label>                -->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--       <div id="drivers_count" class="col-md-12  ocultar">-->
                               <!--         <label for="drivers" data-preferences-target="drivers" class="text-shadow">Cantidad de Conductores</label>-->
                               <!--         <select id="drivers" class="form-control box-shadow"></select>-->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <input type="checkbox" id="supplement_insurance" class="">-->
                               <!--       <label for="supplement_insurance" data-preferences-target="supplementInsurance" class="text-shadow">Suplemento de Edad</label>-->
                               <!--       <span class="helper-text small"></span>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!-- </div>-->
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="bike_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="bike" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="bike" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario BIKE FINNN -->
                             <!-- Formulario TURISMO RURAL -->
                             <div class="tab-pane fade show" id="rural_tourism" role="tabpanel" aria-labelledby="rural_tourism-tab">
                               <div class="row">
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="rural_tourism_to">${I18n.t('reservation.side_bar.destiny')}</label>
                                   <select id="rural_tourism_to" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="rural_tourism_service">${I18n.t('reservation.side_bar.service')}</label>
                                   <select id="rural_tourism_service" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <!-- <label for="rural_tourism_date" data-preferences-target="dateCollect"></label>-->
                                   <label for="rural_tourism_date">${I18n.t('reservation.side_bar.date')}</label>
                                   <input id="rural_tourism_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="rural_tourism_cantidad" data-preferences-target="modality">${I18n.t('reservation.side_bar.person_amount')}</label>
                                   <input type="number" id="rural_tourism_cantidad" class="form-control required" data-action="change->preferences#evaluate blur->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-lg-8">
                                   <label for="rural_tourism_observaciones">${I18n.t('histories.check_reservation.comment')}</label>
                                   <textarea id="rural_tourism_observaciones" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: "></textarea>
                                   <span class="helper-text small"></span>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="rural_tourism_btn" class="form_send" type="button" data-action="b2b#create_reservation" data-validate="rural_tourism" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="rural_tourism" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario TURISMO RURAL FINNN -->
                             <!-- Formulario CABALGATA -->
                             <div class="tab-pane fade show" id="horseback_ride" role="tabpanel" aria-labelledby="horseback_ride-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <label for="horseback_to">${I18n.t('reservation.side_bar.destiny')}</label>
                                       <select id="horseback_to" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <label for="horseback_service">${I18n.t('reservation.side_bar.service')}</label>
                                       <select id="horseback_service" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <!-- <label for="rural_tourism_date" data-preferences-target="dateCollect"></label>-->
                                       <label for="horseback_date">${I18n.t('reservation.side_bar.date')}</label>
                                       <input id="horseback_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <label for="horseback_cantidad" data-preferences-target="modality">${I18n.t('reservation.side_bar.person_amount')}</label>
                                       <input type="number" id="horseback_cantidad" class="form-control required" data-action="change->preferences#evaluate blur->preferences#evaluate keyup->preferences#evaluate" data-min="0" data-max="50" data-block="horseback_ride_btn">
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-12 col-lg-8">
                                       <label for="horseback_observaciones">${I18n.t('histories.check_reservation.comment')}</label>
                                       <textarea id="horseback_observaciones" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: "></textarea>
                                       <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                                 <div class="col-md-12 p-0">
                                   <div class="d-flex justify-content-end" style="padding: 15px 0;width: 100%;">
                                     <button id="horseback_ride_btn" class="form_send" type="button" data-action="b2b#create_reservation" data-validate="horseback_ride" data-addtocart="true">
                                       <span data-preferences-target="textButton" data-validate="horseback_ride" data-addtocart="true"></span>
                                     </button>
                                   </div>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario CABALGATA FINNN -->
                             <!-- Formulario EVENTOS -->
                             <div class="tab-pane fade show" id="events" role="tabpanel" aria-labelledby="events-tab">
                               <div class="row">
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_product">${I18n.t('global.section_an_page.events')}</label>
                                   <select id="event_product" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_modality">${I18n.t('reservation.side_bar.alojam')}</label>
                                   <select id="event_modality" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
<!--                                 <div class="form-group col-12 col-md-6 col-lg-4">-->
<!--                                   <label for="event_category_person">Categoría</label>-->
<!--                                   <select id="event_category_person" class="form-control required"></select>-->
<!--                                   <span class="helper-text small"></span>-->
<!--                                 </div>-->
<!--                                 <div class="form-group col-12 col-md-6 col-lg-4 ocultar">-->
<!--                                   <label for="event_entity">Nombre de entidad</label>-->
<!--                                   <input id="event_entity" class="form-control" type="text">-->
<!--                                   <span class="helper-text small"></span>-->
<!--                                 </div>-->
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_amount">Cantidad de habitaciones</label>
                                   <input id="event_amount" class="form-control required" type="number">
                                   <span class="helper-text small"></span>
                                 </div>
<!--                                 <div class="form-group col-12 col-md-6 col-lg-4">-->
<!--                                   <label for="event_pax">Cantidad de personas</label>-->
<!--                                   <input id="event_pax" class="form-control required" type="number">-->
<!--                                   <span class="helper-text small"></span>-->
<!--                                 </div>-->
                                 
                                 <div class="col-md-12 p-0">
                                   <div class="d-flex justify-content-end" style="padding: 15px 0;width: 100%;">
                                     <button id="event_btn" class="form_send" type="button" data-action="b2b#create_reservation" data-validate="events" data-addtocart="true">
                                       <span data-preferences-target="textButton" data-validate="events" data-addtocart="true"></span>
                                     </button>
                                   </div>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario EVENTOS FINNN -->
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
                `;
            break;
        case 'presentation-information':
            html += ` <div class="presentation-information">
                              <div class="presentation-header">
                                <div class="header-helper">
                                    ${escapeHtml(helpertext || '')}
                                </div>
                                <div class="header-image" >
                                      <img src="${picture}" alt="" loading="lazy" decoding="async">
                                </div>
                              </div>
                              <div class="presentation-body">
                                <div class="title">${escapeHtml(name)}</div>
                                <div class="divider"></div>
                                <div class="content">${description}</div>
                              </div>
                            </div>`
            break;
        case 'presentation-modalities-list':
            /*html += `<div class="presentation-modalities-list" style="--picture: url(${picture})">
                              <div class="presentation-container">
                                <div class="presentation-left">
                                  <div class="helper">${escapeHtml(helpertext)}</div>
                                  <div class="square"></div>
                                </div>
                                <div class="presentation-right">
                                  <div class="title">${escapeHtml(name)}</div>
                                  <div id="section_${id}" class="page-list"></div>
                                </div>
                              </div>
                              <div class="presentation-bottom-image">
                                <img src="${divider_bottom}" alt="" loading="lazy" decoding="async">
                              </div>
                            </div>`*/
            /*html += `<div class="presentation-modalities-list" style="--picture: url(${picture}); height: 100% !important;">
                              <div class="presentation-container">
                                <div class="presentation-all-services">
                                  <div id="section_${id}" class="page-list row" style="color: black;">
                                    <div class="col-12" style="margin-bottom: 1rem;top: -2rem;">
                                      <h3 class="card-title" style="color: white;text-align: center;font-size: 2rem;">${escapeHtml(helpertext)} <b>${escapeHtml(name)}</b> </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="presentation-bottom-image">
                                <img src="${divider_bottom}" alt="" loading="lazy" decoding="async">
                              </div>
                            </div>`*/

            /*<div class="presentation-bottom-image" style="width: 100%; height: 100%;">
                <img src="${picture}" alt="" style="width: 100%; height: 100%;" loading="lazy" decoding="async">
            </div>*/
            html += `<div class="presentation-modalities-list">
                           <div class="presentation-container">
                             <div class="presentation-all-services">
                               <div class="presentation-title" >${escapeHtml(helpertext)} ${escapeHtml(name)} </div>
                               <div id="section_${id}" class="page-list row">
                               </div>
                             </div>
                           </div>
                         </div>`
            break;
        case 'presentation-notice-more-events':
            /* <div class="presentation-header">
                    <div class="side-left">
                      <div class="title">${escapeHtml(name)}</div>
                      <div class="divider"></div>
                      <div class="helper">${escapeHtml(helpertext)}</div>
                    </div>
                    <div class="side-right">
                      <div class="background">
                        <img src="${bg_image}" alt="" loading="lazy" decoding="async">
                      </div>
                      <div class="thumbnail">
                        <img src="${picture}" alt="" loading="lazy" decoding="async">
                      </div>
                    </div>
                  </div> */
            html += `
                  <div class="presentation-notice-more-events" data-controller="tooltip" style="width: 100%">
                      <!-- Va Aquí -->
                      <div class="presentation-body">
                        <div id="event_container" class="events">
                          <div class="title">${I18n.t('global.section_an_page.events')}</div>
                          <!-- <div id="events" class="carousel slide" data-ride="carousel" data-interval="false" data-pause="hover" data-touch="true"> -->
                          <div id="events" class="carousel slide" data-ride="carousel" data-interval="false" data-touch="true">
                            <div id="event_page_${id}" class="carousel-inner pages" style="padding: 25px 5% !important;">
                             
                            </div>
                            <button class="carousel-control-prev event-control" type="button" data-target="#events" data-slide="prev">
                              <span class="fa fa-arrow-left" aria-hidden="true"></span>
                            </button>
                            <button class="carousel-control-next event-control" type="button" data-target="#events" data-slide="next">
                              <span class="fa fa-arrow-right" aria-hidden="true"></span>
                            </button>
                            <div class="swipe-btn d-md-none">
                              <span aria-describedby="tooltip" class="tooltip-button" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="swipe_button">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-hand-move" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                     <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                     <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"></path>
                                     <path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"></path>
                                     <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"></path>
                                     <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"></path>
                                     <path d="M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427"></path>
                                     <path d="M14 3.458c1.32 .354 2.558 .902 3.685 1.612"></path>
                                  </svg>
                              </span>
                              <span id="swipe_button" role="tooltip" class="text-tooltip hide-tooltip" style="font-size: .85em; width: 250px !important; padding: 20px; text-align: start;background: var(--txt-highlight-secondary) !important;box-shadow: 0 0 25px rgba(0,0,0,.5);">
                                   <span class="helper-text">Puede desplazar la pantalla a la izquierda o la derecha para ver más noticias o eventos</span>
                                   <span id="arrow" data-popper-arrow></span>
                                </span>
                            </div>
                          </div>
                        </div>
                        <div id="notice_container" class="notices">
                          <div class="title">${I18n.t('global.section_an_page.notices')}</div>
                          <div id="notices" class="carousel slide" data-ride="carousel" data-interval="false" data-touch="true">
                            <div id="notice_page_${id}" class="carousel-inner pages" style="padding: 25px 5% !important;">
                              
                            </div>
                            <button class="carousel-control-prev notice-control" type="button" data-target="#notices" data-slide="prev">
                              <span class="fa fa-arrow-left" aria-hidden="true"></span>
                            </button>
                            <button class="carousel-control-next notice-control" type="button" data-target="#notices" data-slide="next">
                              <span class="fa fa-arrow-right" aria-hidden="true"></span>
                            </button>
                            <div class="swipe-btn d-md-none">
                              <span aria-describedby="tooltip" class="tooltip-button" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="swipe_button_notices">
                                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-hand-move" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"></path>
                                    <path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"></path>
                                    <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"></path>
                                    <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"></path>
                                    <path d="M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427"></path>
                                    <path d="M14 3.458c1.32 .354 2.558 .902 3.685 1.612"></path>
                                  </svg>
                              </span>
                    
                              <span id="swipe_button_notices" role="tooltip" class="text-tooltip hide-tooltip" style="font-size: .85em; width: 250px !important; padding: 20px; text-align: start;background: var(--txt-highlight-secondary) !important;box-shadow: 0 0 25px rgba(0,0,0,.5);">
                                   <span class="helper-text">Puede desplazar la pantalla a la izquierda o la derecha para ver más noticias o eventos</span>
                                   <span id="arrow" data-popper-arrow></span>
                                </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                `;
            break;
        case 'presentation-with-image-for-page':
            if (has_divider_top) {
                dt = `<div class="col-md-12 presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div>`;
            }

            html += `
                <div class="col-md-12 presentation-with-image-for-page">
                    <div class="row">
                        ${dt}
                    </div>
               
                    <div class="row">
                      <div class="col-md-12">
                        <div class="presentation-title last-word-change">
                          ${escapeHtml(name)}
                        </div>
                      </div>
                    </div>
                    <div id="section_${id}" class="pages-wrapper"></div>
                    <div class="presentation-footer">
                      <a onclick="location.href = '/${sessionStorage.getItem('locale')}/sections/ver/${url}'" class="btn-presentation-footer">
                        ${I18n.t('main.body.read_more')}
                      </a>
                    </div>
                  </div>
                `
            break;
        case 'presentation_with_image_left':
            if (has_divider_top) {
                margin_y = 'margin-y'
                dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
            }
            html += `
                <div class="col-md-12">
                  <div class="presentation-with-image-left">
                    ${dt}
                    <div class="wrapper ${margin_y}">
                        <div class="image-container">
                      
                        <img src="${picture}" alt="${escapeHtml(name)}" loading="lazy" decoding="async">
                        </div>
                        <div class="info-container">
                        <div class="helper-text">
                        ${escapeHtml(helpertext)}
                        </div>
                        <div class="title-text last-word-change">
                        ${escapeHtml(name)}
                        </div>
                        <div class="divider"></div>
                        <div class="description-text">
                        ${description}
                        </div>
                        <div class="button_action">
                            <button onclick="location.href = '/${sessionStorage.getItem('locale')}/sections/ver/${url}'"> ${I18n.t('global.main.read_more')}</button>
                        </div>
                        </div>
                        <div class="page-wrapper">
                            <div class="divider-vertical"></div>
                            <div class="">
                        <ul id="section_${id}" class="pages"></ul>
                        </div>
                        </div>
                    </div>
                  </div>
                </div>
                `;
            break;
        case 'presentation_with_image_5_columns':
            if (has_divider_top) {
                margin_y = 'margin-y'
                dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
            }
            html += `
                <div class="col-md-12">
                  <div class="presentation-with-pages-by-column">
                   ${dt}
                   <div class="wrapper ${margin_y}">
                        <div class="presentation-title">
                          <div class="presentation-text last-word-change"> ${escapeHtml(name)}</div>
                          <div class="divider"></div>
                          <div class="presentation-helper"> ${escapeHtml(helpertext)}</div>
                        </div>
                       
                        <div id="section_${id}" class="presentation-body slick-five-column">
                        </div>
                    </div>
                  </div>
                </div>
                `;
            break;
        case 'presentation_with_image_3_columns':
            if (has_divider_top) {
                margin_y = 'margin-y'
                dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
            }
            html += `
                 <div class="col-md-12 ">
                  <div class="presentation_with_image_3_columns">
                  ${dt}
                   <div class="wrapper ${margin_y}">
                        <div class="presentation-title">
                          <div class="presentation-text last-word-change" > ${escapeHtml(name)}</div>
                          <div class="divider"></div>
                           <div class="presentation-helper" > ${escapeHtml(helpertext)}</div>
                        </div>
                        <div id="section_${id}" class="presentation-body slick-three-column"></div>
                    </div>
                  </div>
                </div>
                `;
            break;
        case 'presentation-whit-image-right':
            if (has_divider_top) {
                margin_y = 'margin-y'
                dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
            }

            html += `<span id="section_${id}_textname" class="ocultar">${escapeHtml(name)}</span>`;
            if (window.innerWidth <= 640) {
                html += `
                <div class="col-md-12">
                  <div class="presentation-whit-image-right">
                  ${dt}
                  <div class="wrapper ${margin_y}">
                    <div class="page-container">
                      <div class="page-header last-word-zoom" data-target="text_section_${id}" data-source="section_${id}_textname">${escapeHtml(name)}</div>
                      <div class="divider"></div>
                       <div class="image-container">
                      <div id="text_section_${id}" class="text-extra"></div>
                         <div class="image-wrapper">
                              <img src="${picture}" alt="${escapeHtml(name)}" loading="lazy" decoding="async">
                            </div>
                        </div>
                      <div class="page-helper-text">${escapeHtml(helpertext)}</div>
                      <div class="page-wrapper">
                        <ul id="section_${id}" class="page-list">
            
                        </ul>
                      </div> 
                      <div class="page-buttons">
                        <button onclick="location.href =location.origin+'/${sessionStorage.getItem('locale')}/sections/ver/${url}'">${I18n.t('global.main.read_more')}</button>
                      </div>
                    </div>
                   </div>
                  </div>
                </div>
                `;
            } else {
                html += `
                <div class="col-md-12">
                  <div class="presentation-whit-image-right">
                  ${dt}
                  <div class="wrapper ${margin_y}">
                  <div class="page-container">
                      <div class="page-header last-word-zoom" data-target="text_section_${id}" data-source="section_${id}_textname">${escapeHtml(name)}</div>
                      <div class="divider"></div>
                      <div class="page-helper-text">${escapeHtml(helpertext)}</div>
                      <div class="page-wrapper">
                        <ul id="section_${id}" class="page-list">
            
                        </ul>
                      </div> 
                      <div class="page-buttons">
                       <button onclick="location.href =location.origin+'/${sessionStorage.getItem('locale')}/sections/ver/${url}'">${I18n.t('global.main.read_more')}</button>
                      </div>
                    </div>
                    <div class="image-container">
                      <div id="text_section_${id}" class="text-extra"></div>
                         <div class="image-wrapper">
                              <img src="${picture}" alt="${escapeHtml(name)}" loading="lazy" decoding="async">
                            </div>
                        </div>
                    </div>
                    
                  </div>
                </div>
                `;
            }
            break;
        case 'presentation_with_image_2_columns':
            if (has_divider_top) {
                margin_y = 'margin-y'
                dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
            }
            html += `
                 <div class="col-md-12 section">
                  <div class="presentation_with_image_2_columns">
                   ${dt}
                    <div id="section_${id}" class="page-container ${margin_y}">
                    </div>
                  </div>
                </div>
                `;
            break;
        case 'presentation-paralax-with-3-columns':
            if (has_divider_top) {
                margin_y = 'margin-y'
                dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
            }

            if (has_divider_bottom) {
                db = `<div class="presentation-divider-bottom"><div class="presentation-divider-bottom" style="--img-dv-top: url(${divider_bottom})"></div></div>`;
            }
            html += `
                 <div class="col-md-12 ">
                  <div class="presentation-paralax-with-3-columns">
                    ${dt}
                    <div class="wrapper">
                         <div class="backgroud-paralax" style="background-image: url('${picture}');">
                          <div class="presentation-wrapper ${margin_y}">
                            <div class="presentation-helper-text">${escapeHtml(helpertext)}</div>
                            <div class="presentation-header">
                              ${escapeHtml(name)}
                            </div>
                            <div class="presentation-description">
                              <div class="description-text">
                                ${description}
                              </div>
                            </div>
                            <div id="section_${id}" class="presentation-pages"></div>
                          </div>
                        </div>          
                    </div>
                   ${db}
                  </div>       
                </div>
                `;
            break;
        case 'presentation-with-notice':
            if (has_divider_top) {
                margin_y = 'margin-y'
                dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
            }
            html += `
                   <div class="col-md-12 section">
                    <div class="presentation-with-notice">
                         ${dt}
                      <div class="notice-container ${margin_y}">
                      <div class="notice-header">
                        <div class="notice-title last-word-change">${escapeHtml(name)}</div>
                        <div class="notice-divider"></div>
                        <div class="notice-helper-text">${escapeHtml(helpertext)}</div>
                      </div>
                        <div class="notice-body">
                         <div id="section_${id}" class="notice-list slick_notice"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                `;
            break;
        case 'presentation-comercial-client':
            html += `
                        <div class="container-fluid">
                          <div class="presentation-comercial-client">
                            <div class="presentation-title col-12 col-md-12">
                              <div class="presentation-text last-word-change" data-controller="word">
                                ${escapeHtml(name)}
                              </div>
                              <div class="mb-3">
                                ${escapeHtml(helpertext)}
                              </div>
                              <div class="divider"></div>
                            </div>
                            <div id="section_${id}" class="presentation-body row"></div>
                          </div>
                        </div>
                `;
            break;
        case 'presentation-with-map':
            homeState.map_section_id = id;
            html += `
                       <div class="presentation-with-map">
                          <div class="left">
                            <div id="overlay_map_load" class="overlay_map_load_left"></div>
                            <div class="for_map" data-controller="map">
                              <div id="map" data-id="${id}"></div>
                            </div>
                          </div>
                          <div class="right">
                            <div class="title">${escapeHtml(name)}</div>
                            <div class="divider"></div>
                            <div class="helper">${escapeHtml(helpertext)}</div>
                          </div>
                        </div>
                `;
            break;
        case 'presentation-review':
            homeState.review_section_id = id;
            homeState.review_section = `section_${id}`;

            html += `
                <div id="review_pre" class="presentation-review">
                  <div class="background" style="--picture: url(${picture})">
                
                  </div>
                  <div class="presentation-body">
                    <div class="title">${escapeHtml(name)}</div>
                    <div class="body" data-controller="carousel">
                      <div id="review" class="carousel slide carousel-fade modifi_behavior_carousel" data-ride="carousel" data-interval="false" data-touch="true">
                        <div id="section_${id}" class="carousel-inner"></div>
                        <button class="carousel-control-prev" type="button" data-target="#review" data-slide="prev">
                            <span class="fa fa-arrow-left" aria-hidden="true"></span>
                          </button>
                          <button class="carousel-control-next" type="button" data-target="#review" data-slide="next">
                            <span class="fa fa-arrow-right" aria-hidden="true"></span>
                          </button>

                      </div>
                    </div>
                  </div>
                  <div class="bottom">
                   <img src="${divider_bottom}" alt="" loading="lazy" decoding="async">
                  </div>
                </div>
                `;
            break;
        case 'presentation-gallery':
            homeState.section_gallery = id;

            html += `
                <div id="presentation_gallery_${id}" class="presentation-gallery">
                  <div class="row">
                    <div class="col-12 col-md-4" >
                      <div class="visor-image">
                        <div class="title">${escapeHtml(name)}</div>
                        <div class="helper-text">
                          ${escapeHtml(helpertext)}
                        </div>
                        <div class="description">
                          ${description}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8">
                      <div id="presentation_magic_masonry_${id}" class="carousel slide carousel-fade" data-ride="carousel" data-touch="true" data-interval="false">
                        <div id="section_${id}" class="carousel-inner">
                         
                        </div>
                        <div id="button_magic_masonry_${id}">
                        <button class="carousel-control-prev" type="button" data-target="#presentation_magic_masonry_${id}" data-slide="prev">
                          <span class="fa fa-arrow-left"></span>
                        </button>
                        <button class="carousel-control-next" type="button" data-target="#presentation_magic_masonry_${id}" data-slide="next">
                          <span class="fa fa-arrow-right"></span>
                        </button>
                        </div>
                      </div>
                
                    </div>
                  </div>
                </div>
                `;
            break;
        case 'presentation-gallery-lightbox':
            homeState.section_gallery = id;

            html += `
                <div id="presentation_gallery_${id}" class="presentation-gallery">
                  <div class="row" style="margin: 2rem;">
                    <div class="col-12 col-md-4" >
                      <div class="visor-image">
                        <div class="title">${escapeHtml(name)}</div>
                        <div class="helper-text">
                          ${escapeHtml(helpertext)}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8" style="padding: 2rem; backdrop-filter: blur(5px); box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);">
                      <div data-controller="catalogo" style="max-height: 80vh; overflow: scroll;">
                        <div class="masonry" data-catalogo-target="galeria"></div>
                      </div>
                    </div>
                  </div>
                </div>
                `;
            break;
        case 'faqs':
            html += `
                 <div class="container-fluid mb-5" style="width: 80%">
                  <div class="row my-5">
                      <div class="col-12 ">
                        <div id="faqs"  class="presentation-faq">
                          <h2>${escapeHtml(name)}</h2>
                          <div class="accordion mt-3" id="section_${id}" data-controller="faqs"></div>
                        </div>
                      </div>
                  </div>
                </div>
                `;
            break;
    }

    html += `</div></section>`;

    return html;
}


export function tpl_section_footer(id, url, name, type) {
    let html = ``;
    switch (type) {
        case 'footer':
            html += `
                   <div class="footer-section">
                    <div class="footer-section-title">
                      ${escapeHtml(name)}
                    </div>
                    <div id="section_${id}" class="section-page-wrapper">
                    </div>
                  </div>
                `;
            break;
    }
    return html;
}


export function tpl_page(id, url, isExternal, name, description, type, picture, icon, count = 0, has_div_top = false, div_top = '', has_dv_bottom = false, dv_bottom = '', show_more_page) {
    let des = description || ' ';
    let html = ``;
    let dt = '';
    let db = '';

    switch (type) {
        case 'presentation-with-image-for-page':
            let aa_ifp = 'javascript:;';
            if (show_more_page) {
                aa_ifp = url;
            }
            html += `
                 <div class="page-item">
                   ${dt}
                   <a href="${aa_ifp}" target="_blank">
                     <div class="image-page">
                       <img src="${picture}" loading="lazy" decoding="async">
                     </div>
                     <div class="text-page">
                       ${escapeHtml(name)}
                     </div>
                   </a>
                   ${db}
                 </div>`;
            break;
        case 'presentation-modalities-list':
            let aa_mod_list = 'javascript:;';
            if (show_more_page) {
                aa_mod_list = url;
            }
            /*html = `<a href="${url}" class="page">
                          <span class="icon">
                            ${icon}
                          </span>
                          <span class="page-name">${escapeHtml(name)}</span>
                        </a>`;*/
            /*html = `<div class="col-md-6 col-xl-4 page d-flex" style="margin-bottom: 1rem">
                          <div class="card h-100 w-100" style="min-height: 15rem;">
                            <div class="card-body d-flex align-items-center p-0 overflow-hidden">
                              <!-- Imagen - 35% del ancho -->
                              <div class="d-flex align-items-center justify-content-center bg-light" style="width: 95%; height: 100%;">
                                ${icon}
                              </div>
                              <!-- Contenido textual - 65% del ancho -->
                              <div class="p-3 w-100">
                                <h5 class="card-title mb-2">${escapeHtml(name)}</h5>
                                <p class="card-text mb-3" style="font-size: 0.9rem; overflow: scroll; max-height: 8rem;">
                                  ${description}
                                </p>
                                <a href="#" class="btn btn-primary btn-sm d-block">Go somewhere</a>
                              </div>
                            </div>
                          </div>
                        </div>`;*/
            html = `<div class="card">
                          <a id="card_page_url" href="${url}">
                            <div class="card-body d-flex flex-column justify-content-between align-items-center p-0 overflow-hidden">
                              <div class="card-img">
                                <img class="" src="${picture}" alt="${escapeHtml(name)} - ${escapeHtml(description)}" width="375" height="500" loading="lazy" decoding="async">
                              </div>
                              <!-- Contenido textual - 65% del ancho -->
                              <div class="card-container p-3 w-100">
                                <h1 class="card-title mb-2">${escapeHtml(name)}</h1>
                                <p class="card-text mb-3" style="display: none;">
                                  ${escapeHtml(description)}
                                </p>
                                <!-- <a href="${url}" class="card-buttons btn btn-primary btn-sm d-block">Ir a la página</a>-->
                                <span class="card-buttons btn btn-primary btn-sm" style="display: none;">Ir a la página</span>
                              </div>
                            </div>
                          </a>
                        </div>`;
            break;
        case 'presentation-notice-more-events':
            /*let active = '';
            if (count === 0) {
                active = 'active';
            }*/

            let aa_n_e = '';
            if (show_more_page) {
                aa_n_e = `<a class="a-link" href="${url}" target="_blank">${I18n.t('main.body.read_more')}</a>`;
            }
            // <div  class="carousel-item ${active}">
            html += `
                        <div class="page col-12 col-md-6 mb-3">
                            <div class="left">
                                <img src="${picture}" alt="" loading="lazy" decoding="async">
                                ${aa_n_e}
                            </div>
                            <div class="right">
                                <div class="title">${escapeHtml(name)}</div>
                                <div class="helper">${escapeHtml(description)}</div>
                            </div>
                        </div>
                    `;
            // </div>
            break;
        case 'presentation_with_image_left':
            html = `
                    <li class="page-section">
                      <div class="page-icon">
                        ${icon}
                      </div>
                      <div class="page-container">
                        <div class="page-title">
                          ${escapeHtml(name)}
                        </div>
                        <div class="divider"></div>
                        <div class="page-body">
                          ${escapeHtml(des)}
                        </div>
                     </div>
                    </li>`;
            break;
        case 'presentation_with_image_5_columns':
            let aa_5 = '';
            if (show_more_page) {
                aa_5 = `<div class="page-buttons">
                              <button onclick="location.href = '${url}'">${I18n.t('global.main.read_more')}</button>
                            </div>`;
            }
            html = `<div class="">
                          ${dt}
                          <div class="page-card">
                            <div class="page-slider">
                              <div class="page-card-image">
                                <img src="${picture}" alt="${escapeHtml(name)}" loading="lazy" decoding="async">
                              </div>
                              <div class="page-card-body">
                                <div class="page-title">
                                  ${escapeHtml(name)}
                                </div>
                                <div class="page-divider"></div>
                                <div class="page-helper">
                                  ${escapeHtml(description)}
                                </div>
                                ${aa_5}
                              </div>
                            </div>
                          </div>
                        </div>
                        ${db}
                        </div>`;
            break;
        case 'presentation_with_image_3_columns':
            let aa_3 = 'javascript:;';
            if (show_more_page) {
                aa_3 = url;
            }
            html = ` 
                 <div class="">
                  ${dt}
                 <div class="page-card">
                                  <div class="page-slider">
                                    <div class="page-card-image">
                                      <img src="${picture}" alt="${escapeHtml(name)}" loading="lazy" decoding="async" onclick="location.href = '${url}'">
                                    </div>
                                    <div class="page-title">
                                      ${escapeHtml(name)}
                                    </div>
                                    <div class="page-divider"></div>
                                  </div>
                                </div>
                                 ${db}
                </div>
                 `;
            break;
        case 'presentation-whit-image-right':
            html = ` <li>
                    <div class="page-icon">
                      ${icon}
                    </div>
                    <div class="page-container">
                      <div class="page-title">${escapeHtml(name)}</div>
                      <div class="divider-page"></div>
                    </div>
                  </li>`;
            break;
        case 'presentation_with_image_2_columns':
            let aa_2 = '';
            if (show_more_page) {
                aa_2 = `<button onclick="location.href = '${url}'">${I18n.t('global.main.read_more')}</button>`;
            }
            let text = des.slice(0, 250);
            html = ` <div class="page">
                ${dt}
                <div class="page-image-container">
                <div class="overlay"></div>
                  <img src="${picture}" alt="${escapeHtml(name)}" loading="lazy" decoding="async">
                </div>
                <div class="page-body-container">
                  <div class="body-header">${escapeHtml(name)}</div>
                  <div class="body-text">${escapeHtml(text)}...</div>
                  <div class="body-button">
                    ${aa_2}
                  </div>
                </div>
                 ${db}
              </div>`;
            break;
        case 'presentation-paralax-with-3-columns':
            let aa_paralax_3 = 'javascript:;';
            if (show_more_page) {
                aa_paralax_3 = url;
            }
            html = `
                  <div class="page">
                    <button onclick="location.href = '${aa_paralax_3}'">${escapeHtml(name)}</button>
                  </div>
                `;
            break;
        case 'presentation-with-notice':
            let aa_n = '';
            if (show_more_page) {
                aa_n = `<button type="button" onclick="location.href = '${url}'">${I18n.t('global.main.read_more')}</button>`;
            }
            html += `
                    <div class="">
                     ${dt}
                     <div class="notice">
                        <div class="n-picture">
                          <img src="${picture}" alt="${escapeHtml(name)}" loading="lazy" decoding="async">
                        </div>
                        <div class="n-divider"></div>
                        <div class="n-wrapper">
                        <div class="n-title">
                          ${escapeHtml(name)}
                        </div>               
                        <div class="n-body">
                          ${escapeHtml(des)}
                        </div>
                        <div class="n-footer">
                          ${aa_n}
                        </div>   
                        </div>       
                      </div>
                       ${db}
                    </div>
                `;
            break;
        case 'presentation-comercial-client':
            html += `<div class="col-6 col-sm-6 col-md-4 col-lg-2 mb-5">
                           <div class="card-comercial">
                             <div class="image-container">
                               <img src="${picture}" alt="${escapeHtml(name)}" loading="lazy" decoding="async">
                             </div>
                             <div class="image-text d-flex justify-content-center">
                               <div class="divider"></div>
                             </div>
                           </div>
                         </div>`;
            break;
    }

    return html;
}


export function tpl_catalog(id, category, category_id, picture, price, description, showButton) {
    let buyBtn = '';
    let btn_text = I18n.t('main.body.catalog.rent_btn');
    if (showButton) {
        buyBtn = `<a href="javascript:;" class="buy-btn" data-action="setValue#pre_reservation" data-id="${id}"   data-category="${escapeHtml(category)}" data-categoryid="${category_id}" data-description="${description}"  >${btn_text}</a>`;
    }
    return `<div class="">
                  <div class="box">
                    <div class="slider-img">
                      <img src="${picture}" alt="${escapeHtml(category)}" loading="lazy" decoding="async">
                      <div class="overlay">
                        ${buyBtn}
                      </div>
                    </div>
                    <div class="detail-btn">
                      ${buyBtn}
                    </div>
                    <div class="details-box">
                      <div class="type">
                        <a href=""></a>
                        <span>${escapeHtml(category)}</span>
                      </div>
                      <a href="" class="price">
                        ${I18n.t('main.body.catalog.from')} $${escapeHtml(price)}.00
                      </a>
                    </div>
                    <div class="detail-description">
                      <div class="title-description">
                        ${I18n.t('main.body.catalog.description')}
                      </div>
                      <div class="desciption-body">
                        ${description}
                      </div>
                    </div>
                  </div>
                </div>`;
}


export function tpl_page_footer(id, url, isExternal = false, name, icon = null, show_more_page) {
    let html = '';

    if (icon !== null && icon.includes('fa')) {
        icon = `fa ${icon}`;
    }

    let url_show_more_page = 'javascript:;';
    if (show_more_page) {
        url_show_more_page = url;
    }


    if (isExternal) {
        html = `<div class="footer-link">
                      <a href="${url_show_more_page}" target="_blank">${icon} ${escapeHtml(name)}</a>
                    </div>`;
    } else {
        html = `<div class="footer-link">
                      <a href="${url_show_more_page}" >${icon} ${escapeHtml(name)}</a>
                    </div>`;
    }
    return html
}


